
import VisibilityIcon from '@mui/icons-material/Visibility';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { useImpersonation } from '../hooks/useImpersonation';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export const ImpersonationBanner = () => {
    const { isImpersonating, impersonatedProfile, stopImpersonation } = useImpersonation();

    if (!isImpersonating || !impersonatedProfile) {
        return null;
    }

    const handleStop = async () => {
        if (confirm('Are you sure you want to exit impersonation mode?')) {
            try {
                await stopImpersonation();
            } catch (error) {
                console.error('Failed to stop impersonation:', error);
                alert('Failed to stop impersonation. Please try again.');
            }
        }
    };

    return (
        <Alert
            severity="warning"
            icon={<VisibilityIcon />}
            sx={{
                position: 'sticky',
                top: 0,
                zIndex: 9999,
                borderRadius: 0,
                '& .MuiAlert-message': {
                    width: '100%'
                }
            }}
            action={
                <Button
                    color="inherit"
                    variant="outlined"
                    startIcon={<ExitToAppIcon />}
                    onClick={handleStop}
                    sx={{
                        borderColor: 'warning.dark',
                        '&:hover': {
                            borderColor: 'warning.dark',
                            bgcolor: 'rgba(0, 0, 0, 0.08)'
                        }
                    }}
                >
                    Exit
                </Button>
            }
        >
            <Stack direction="row" spacing={2} alignItems="center">
                <Chip
                    label="IMPERSONATION MODE"
                    size="small"
                    color="error"
                    sx={{ fontWeight: 'bold' }}
                />
                <Typography fontWeight="bold" variant="body2">
                    Viewing as: {impersonatedProfile.displayName}
                </Typography>

            </Stack>
        </Alert>
    );
};
